import {FunctionComponent} from 'react'

import { Typography, Card, CardContent, Stack, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

export interface ToolbarProps {
  icon: any;
  title: string;
  items?: any;
  columnGap?: any;
}


export const Toolbar: FunctionComponent<ToolbarProps> = ({icon, title, items, columnGap}) => {

  return (<>
    <Card variant='outlined' style={{minHeight: "68px"}}>
      <CardContent style={{paddingBottom: "7px"}}>
        <Grid container>
          <Grid display="flex" alignItems="center">
            <Typography style={{marginBottom: "7px"}} variant='h6'>{icon}{title}</Typography>
          </Grid>
          <Grid size="grow"></Grid>
          <Grid size="auto" className="toolbar-buttons">
            <Stack direction="row" useFlexGap sx={{ rowGap: 2, flexWrap: 'wrap', marginBottom: "7px", columnGap: columnGap || 1 }}>
              {items}
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  </>)
}